import $ from 'jquery';
import { IS_ACTIVE_CLASS } from '../constants/classes';
import { ALERT_MESSAGE_CLASS } from '../constants/classes';
import { ERROR_MESSAGE_CLASS } from '../constants/classes';

/**
 * An object of selectors used in this file
 * @property SELECTORS
 * @type {Object}
 * @final
 */
const SELECTORS = {
    SITE_MESSAGE_CONTAINER: '.js-siteMessage',
    SITE_MESSAGE: '.js-siteMessage-inner-message',
};

/**
 * Global Notifications class
 *
 * @class Notifications
 * @constructor
 */
export default class Notifications {
    constructor() {
        this.createChildren();
    }

    createChildren() {
        this.$siteMessage = $(SELECTORS.SITE_MESSAGE);
        this.$siteMessageContainer = $(SELECTORS.SITE_MESSAGE_CONTAINER);
        return this;
    }

    /**
     * Displays message at top of page
     * for server errors when a fetch
     * fails
     *
     * @method showErrorNotification
     * @public
     * @chainable
     */
    showErrorNotification(messageOrTemplate, messageTypeClass) {
        this.resetMessages();
        this.$siteMessageContainer.addClass(messageTypeClass).addClass(IS_ACTIVE_CLASS);
        this.$siteMessage.html(messageOrTemplate);
        this.$siteMessageContainer.focus();
    }

    /**
     * Resets notifications container
     * before it's used for a specific message
     * purpose
     *
     * @method resetMessages
     * @public
     * @chainable
     */
    resetMessages() {
        this.$siteMessageContainer
            .removeClass(IS_ACTIVE_CLASS)
            .removeClass(ALERT_MESSAGE_CLASS)
            .removeClass(ERROR_MESSAGE_CLASS);
        this.$siteMessage.text('');
    }
}